import useAllRows from '@/hooks/use-all-rows';
import { APP_COLLECTIONS, AppCategory } from '@polybank/shared';
import { useMemo } from 'react';

export default function useCategories() {
  const resultRaw = useAllRows(APP_COLLECTIONS.CATEGORIES, {
    sortBy: 'name',
    sortOrder: 'asc',
  });

  const nameToIdMap = useMemo(() => {
    return resultRaw.data?.rows.reduce(
      (acc, curr) => {
        if (curr.name) {
          acc[curr.name!.toLowerCase()] = curr;
        }
        return acc;
      },
      {} as Record<string, AppCategory>
    );
  }, [resultRaw.data?.rows]);
  const result = useMemo(() => {
    return {
      data: { rows: resultRaw.data?.rows ?? [] },
      categoriesMap: resultRaw.rowsMap,
      addItem: resultRaw.addItem,
      updateItem: resultRaw.updateItem,
      removeItem: resultRaw.removeItem,
      isLoading: resultRaw.isLoading,
      nameToIdMap,
    };
  }, [resultRaw, nameToIdMap]);
  return result;
}
